import React, {createContext} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    withStyles,
    Grid,
    Typography
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {IconFechar} from "../components/icons/MateraIcons";
import Divider from '@material-ui/core/Divider';

export const Context = createContext({});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class Provider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            status: false,
            dialog: this.initialState
        };
    }


    close = (e) => {
        e?.preventDefault?.();
        this.setState({status: false});
        setTimeout(() => {
            this.setState({dialog: this.initialState});
        }, 300)
    };


    open = (values) => {
        this.setState({
            status: true,
            dialog: {
                ...this.initialState,
                ...values
            }
        });
    };

    openShortcut = () => this.open({
        title: 'Atalhos',
        size: 'sm',
        actions: <>
            <Button onClick={this.close} style={{marginBottom: 10}}>Fechar</Button>
        </>,
        content: <>
            <ul>
                <Divider orientation={'horizontal'}/>
                <li key={'campos'}><Typography variant="overline">Campos de data e hora:</Typography></li>
                <li key={'CtrlAU'}>+1 mes ou +1 hora (Ctrl + ↑)</li>
                <li key={'ArrowU'}>+1 dia ou +1 minuto (↑)</li>
                <li key={'CtrlAD'}>-1 mes ou -1 hora (Ctrl + ↓)</li>
                <li key={'ArrowD'}>-1 dia ou -1 minuto (↓)</li>
            </ul>
        </>
    })

    initialState = {
        noFullWidth: false,
        noActionButtons: false,
        onClose: this.close,
        onAccept: this.close,
        actions: null,
        title: '',
        content: <></>,
        size: 'md',
        isSubmitting: false,
    };

    submiting = (state = true) => {
        this.setState({
            dialog: {
                ...this.state.dialog,
                isSubmiting: state,
            }
        });
    }

    get dialogContext() {
        return {
            status: this.state.status,
            close: this.close,
            open: this.open,
            dialog: this.state.dialog,
            submiting: this.submiting,
            openShortcut: this.openShortcut,
        };
    }

    render() {
        const props = this.props;
        return <Context.Provider value={this.dialogContext}>
            {props.children}
            <Dialog
                fullWidth={!this.state.dialog.noFullWidth}
                maxWidth={this.state.dialog.size}
                open={this.state.status}
                TransitionComponent={Transition}
                onClose={this.state.dialog.onClose}
                aria-labelledby="draggable-dialog-title"
                backdropClick
                className={props.classes.dialog}
                PaperProps={{}}
            >
                <DialogTitle id="form-dialog-title" className={props.classes.title}>
                    <Grid container justifyContent={"space-between"} className={props.classes.titleContainer}>
                        {
                            this.state.dialog.title
                        }
                        <IconButton size={'small'} onClick={this.state.dialog.onClose}
                                    style={{justifySelf: 'flex-end'}}>
                            <IconFechar size={16}/>
                        </IconButton>
                    </Grid>
                </DialogTitle>
                <DialogContent className={props.classes.noPaddingBottom}>
                    {
                        this.state.dialog.content
                    }
                </DialogContent>
                {
                    !this.state.dialog.noActionButtons &&
                    <DialogActions className={props.classes.actions}>
                        {
                            this.state.dialog.actions ||
                            <Grid container className={props.classes.root}>
                                <Grid item xs={12}>
                                    <Grid container justifyContent={'flex-end'} direction={'row'}
                                          className={this.props.classes.spacingActions} spacing={5}>
                                        <Grid item>
                                            <Button onClick={this.state.dialog.onClose}
                                                    disabled={this.state.dialog.isSubmiting}
                                                // color="primary"
                                            >
                                                Cancelar
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button onClick={this.state.dialog.onAccept}
                                                    disabled={this.state.dialog.isSubmiting}
                                                // color="primary"
                                                    variant="outlined">
                                                Ok
                                            </Button>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>

                        }
                    </DialogActions>
                }
            </Dialog>
        </Context.Provider>;
    };
}

const style = theme => ({
    root: {
        flexGrow: 1,
    },
    actions: {
        padding: '0 24px',
        marginBottom: 10,
    },
    title: {
        padding: '10px 24px 10px',
    },
    noPaddingBottom: {
        paddingBottom: 0,
        overflow: 'visible',
        overflowX: 'hidden',
        [theme.breakpoints.down('sm')]: {
            overflow: 'auto',
        }
    },
    spacingActions: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        marginBottom: 5
    },
    dialog: {
        '& .MuiDialog-paperFullWidth': {
            margin: 0,
            width: '100%',
            overflow: 'visible'
        },
    },
    titleContainer: {
        flexWrap: 'nowrap',
    }
});

export const DialogProvider = withStyles(style)(Provider);

const {Consumer} = Context;

export const withDialog = (Child) => (props) => <Consumer>
    {
        dialog => {
            window.dialogWindow = dialog
            return <Child {...props} dialog={dialog}/>
        }
    }
</Consumer>;


